import { CardElement } from '@stripe/react-stripe-js';
import { Box } from '@mui/material';

interface Props {
  disabled?: boolean;
}

export default function CheckoutElementsForm({ disabled }: Props) {
  return (
    <Box width="100%" boxSizing="border-box">
      <Box
        boxSizing="border-box"
        p={1.5}
        border={theme => `1px solid ${theme.palette.outlineGrey.main}`}
        bgcolor="#ffffff"
        borderRadius="5px">
        <CardElement
          options={{
            disableLink: true,
            disabled,
            style: {
              base: {
                fontFamily: 'Montserrat, sans-serif',
              },
            },
          }}
        />
      </Box>
    </Box>
  );
}
